import BaseApi from "./baseApi";

class retreatClosureApi extends BaseApi {
  async getAllRetreatClosures(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/closure/get-all-retreat-closures",
      data: data,
      method: "post",
    });
  }

  async sendMailToLead(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/closure/send-mail-to-lead",
      data: data,
      method: "post",
    });
  }

  async getMailRecipients(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/closure/get-mail-recipients",
      data: data,
      method: "post",
    });
  }

  
}

export default retreatClosureApi;
